import { IconButton } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";

interface BackButtonProps {
  onClick: () => void;
  color?: string;
  size?: "small" | "medium" | "large";
  iconSize?: string;
  sx?: object;
}

export default function BackButton({
  onClick,
  color = "text.primary",
  size = "medium",
  iconSize = "24px",
  sx = {},
}: BackButtonProps) {
  return (
    <IconButton onClick={onClick} sx={{ color, ...sx }} size={size}>
      <ArrowBack sx={{ fontSize: iconSize }} />
    </IconButton>
  );
}
